





























































































































































import { Vue, Component } from 'vue-property-decorator'

import { Instance } from '../../../shared/models/instance.model'
import { getConfig } from '../shared/config'
import { listInstances } from '../shared/instance-http'
import faSmile from '@fortawesome/fontawesome-free-solid/faSmile'
import faMeh from '@fortawesome/fontawesome-free-solid/faMeh'
import faFrown from '@fortawesome/fontawesome-free-solid/faFrown'
import debounce from 'lodash/debounce'

@Component
export default class InstanceList extends Vue {
  columns = [
    {
      label: 'Name',
      field: 'name',
      sortable: true,
      tdClass: 'name'
    },
    {
      label: 'URL',
      field: 'host',
      sortable: true,
      tdClass: 'host'
    },
    {
      label: 'Version',
      field: 'version',
      sortable: true,
      tdClass: 'version'
    },
    {
      label: 'Following',
      field: 'totalInstanceFollowing',
      sortable: true,
      type: 'number'
    },
    {
      label: 'Followers',
      field: 'totalInstanceFollowers',
      sortable: true,
      type: 'number'
    },
    {
      label: 'Local videos',
      field: 'totalLocalVideos',
      sortable: true,
      type: 'number'
    },
    {
      label: 'Total videos',
      field: 'totalVideos',
      sortable: true,
      type: 'number'
    },
    {
      label: 'Users',
      field: 'totalUsers',
      sortable: true,
      type: 'number'
    },
    {
      label: 'Signup',
      field: 'signupAllowed',
      type: 'boolean',
      sortable: true
    },
    {
      label: 'Live',
      field: 'liveEnabled',
      type: 'boolean',
      sortable: true
    },
    {
      label: 'Location',
      field: 'country',
      type: 'string',
      sortable: true
    },
    {
      label: 'Health',
      field: 'health',
      sortable: true,
      type: 'number'
    }
  ]

  rows: Instance[] = []
  totalRecords: number | null = null

  perPage = 10

  searchTerm = ''
  category: string

  paginationOptions = {
    enabled: true,
    perPage: this.perPage
  }

  onSearch = debounce(this.onSearchImpl.bind(this), 500)

  topTextHtml = ''

  private search = ''
  private sort = '-createdAt'
  private currentPage = 1

  async mounted () {
    this.setTableFromQueryParams()

    this.loadData()

    const config = await getConfig()
    this.topTextHtml = config.instanceClientWarning
  }

  getUrl (host: string) {
    return 'https://' + host
  }

  getIcon (health: number) {
    if (health > 90) return faSmile
    if (health > 50) return faMeh
    return faFrown
  }

  getIconColor (health: number) {
    if (health > 98) return '#08cd36'
    if (health > 90) return '#81c307'
    if (health > 70) return '#cfb11b'
    if (health > 50) return '#e67a3c'
    if (health > 20) return '#e7563c'

    return '#f44141'
  }

  getInstanceNameTitle (instance: Instance) {
    return instance.name + '\nAdded on ' + new Date(instance.createdAt).toLocaleString()
  }

  onPageChange (params: { currentPage: number }) {
    this.currentPage = params.currentPage
    this.setQueryParam('page', this.currentPage)
    this.loadData()
  }

  onPerPageChange (params: { currentPerPage: number }) {
    this.perPage = params.currentPerPage
    this.currentPage = 1
    this.setQueryParam('page', this.currentPage)
    this.loadData()
  }

  onSortChange (params: any) {
    const newSort = params[0]

    this.sort = newSort.type === 'asc' ? '' : '-'
    this.sort += newSort.field

    this.setQueryParam('sort', this.sort)

    this.loadData()
  }

  private setQueryParam (name: string, value: string | number) {
    let query = { ...this.$route.query }

    if (value) query = Object.assign(query, { [name]: value })
    else delete query[name]

    this.$router.push({
      path: this.$route.path,
      query
    })
  }

  private setTableFromQueryParams () {
    for (var key in this.$route.query){
      if (key === 'sort') {
        this.sort = this.$route.query[key] as string
      } else if (key === 'page') {
        this.currentPage = +this.$route.query[key]
      } else if (key === 'search') {
        this.search = this.searchTerm = this.$route.query[key] as string
      }
    }
  }

  private onSearchImpl (params: { searchTerm: string }) {
    this.search = params.searchTerm
    this.setQueryParam('search', this.search)
    this.loadData()
  }

  private async loadData () {
    const response = await listInstances({
      page: this.currentPage,
      perPage: this.perPage,
      sort: this.sort,
      search: this.search
    })

    this.rows = response.data
    this.totalRecords = response.total
  }
}
